import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Card, CardHeader, CardBody, Row, Col, Button, Input, Label, Form, FormGroup, Alert, FormFeedback } from 'reactstrap'
import { validationHelper, normalizeHelper } from '../../../../common/helpers'
import { messages } from '../../../../common/constants'
import { toast } from 'react-toastify'
import { getProvider, updateProvider, resetProvider, resetUpdateProvider } from '../../../../store/provider/actions'
import { MainLoader } from '../../../../components'

class ProviderEdit extends Component {

    constructor(props) {
        super(props)

        this.onSubmit = this.onSubmit.bind(this)
    }


    componentDidMount() {
        this.props.getProvider(this.props.match.params.id)
    }
    componentWillUnmount() {
        this.props.resetProvider();
        this.props.resetUpdateProvider();
    }

    onSubmit(values) {
        this.props.updateProvider(this.props.match.params.id, values, () => {
            toast.success('Proveedor actualizado satisfactoriamente')
            this.props.history.push('/administration/providers')
        })
    }

    renderInputField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label className={labelClass} >{field.label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} invalid={hasError} type={field.type} />
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }


    render() {
        const { handleSubmit, error, loading, updatedLoading, updatedError } = this.props
        const isLoadingFetch = (loading)
        const isLoadingSubmit = (updatedLoading)

        if (error) {
            return (
                <Alert color="danger">
                    {error}
                </Alert>
            )
        }
        if (isLoadingFetch) {
            return <MainLoader />
        }
        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        Editar Proveedor
                    </CardHeader>
                    <CardBody>
                        {
                            updatedError && (
                                <Alert color="danger">
                                    {updatedError}
                                </Alert>
                            )
                        }
                        <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))} >
                            <Field name='name' label='Nombre *:' type='text' component={this.renderInputField} normalize={normalizeHelper.letterOnlyField()} />
                            <Field name='ruc' label='RUC *:' type='text' component={this.renderInputField} normalize={normalizeHelper.numberOnlyField(11)} />
                            <Field name='phone' label='Teléfono *:' type='text' component={this.renderInputField} normalize={normalizeHelper.numberOnlyField(9)} />
                            <Field name='email' label='Email:' type='text' component={this.renderInputField} normalize={normalizeHelper.emailOnlyField()} />
                            <Field name='bank' label='Banco:' type='text' component={this.renderInputField} normalize={normalizeHelper.letterOnlyField()} />
                            <Field name='bankAccount' label='Cuenta:' type='text' component={this.renderInputField} normalize={normalizeHelper.noSpecialsField()} />
                            <Field name='comments' label='Comentarios:' type='textarea' component={this.renderInputField} />

                            <Row>
                                <Col className='mt-3'>
                                    <Button type='submit' disabled={isLoadingSubmit} color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                                    <Button color='secondary' onClick={() => this.props.history.push('/administration/providers')} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

function validate(values) {
    const errors = {}

    if (validationHelper.stringIsNullOrEmpty(values.name)) {
        errors.name = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.lettersOnly(values.name)) {
        errors.name = messages.LETTERS_ONLY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.ruc)) {
        errors.ruc = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.isNumber(values.ruc, 11)) {
        errors.ruc = messages.RUC_FORMAT_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.phone)) {
        errors.phone = messages.MANDATORY_FIELD
    }
    else if (!validationHelper.isPhone(values.phone)) {
        errors.phone = messages.PHONE_FORMAT_FIELD
    }

    if (!validationHelper.isEmail(values.email) && !validationHelper.stringIsNullOrEmpty(values.email)) {
        errors.email = messages.EMAIL_FORMAT_FIELD
    }

    if (!validationHelper.lettersOnly(values.bank)) {
        errors.bank = messages.LETTERS_ONLY_FIELD
    }

    if (!validationHelper.noSpecialCharacters(values.bankAccount)) {
        errors.bankAccount = messages.NO_SPECIAL_CHARACTER_FIELD
    }

    return errors
}

function mapStateToProps(state) {

    const { provider, error, loading } = state.provider.activeProvider

    return {
        initialValues: provider,
        loading,
        error,
        updatedStore: state.provider.updateProvider.provider,
        updatedError: state.provider.updateProvider.error,
        updatedLoading: state.provider.updateProvider.loading

    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getProvider,
        updateProvider,
        resetProvider,
        resetUpdateProvider
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'ProviderEditForm',
    touchOnBlur: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    validate
})(ProviderEdit))



// WEBPACK FOOTER //
// ./src/scenes/Administration/Provider/ProviderEdit/ProviderEdit.js